export default {
    namespaced: true,
    state: () => ({
        status: "Avrora.Objects.Modules.Docflow.DocflowObjects.ActItem",
        search: null,
        extendedFilter: {
            EFResolutionText: {
                label: "Краткое_содержание",
                value: null
            },
            RegNumber: {
                label: "Рег._номер",
                value: null
            },
            RegDateFrom: {
                label: "Дата_регистрации_c",
                value: null
            },
            RegDateTo: {
                label: "Дата_регистрации_по",
                value: null
            },
            ResolutionAuthor: {
                label: "Автор",
                value: []
            },
            ExecuterWorkStatus:  {
                label: "Статус",
                value: null
            },
            ExecuterEnterpriseId: {
                label: "Исполнитель",
                value: null
            }
        },
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "currentlimit" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_STATUS (state, payload) {
            state.status = payload;
            state.tableOptions.page = 1;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
            state.tableOptions.page = 1;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
            state.tableOptions.page = 1;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getStatus: (s) => s.status,
        getSearch: (s) => s.search,
        getExtendedFilter: (s) => s.extendedFilter,
    }
}